import { ActionTypes } from '../constans/action-types';

export const setUserData = data => ({
  type: ActionTypes.SET_USER_DETAILS,
  data: data,
});
